// extracted by mini-css-extract-plugin
module.exports = {"modal":"ProductView_modal__0Q6zZ"};